import React from "react";
import { Grid, MenuItem, TextField, Typography, Box } from "@mui/material";
import { DutToZeroMechanics } from "../../models/mechanicsConfiguration.ts";
import { ImageBox } from "../../components/ImageBox.tsx";
interface Props {
  data: DutToZeroMechanics;
  onChange: (field: string, value: any) => void;
}

const DutToZeroMechanicsForm: React.FC<Props> = ({ data, onChange }) => {
  return (
    <>
      <Typography variant="h6" gutterBottom>
        Anordnung "Nullpunkt-Konstruktion" zu "DUT-Nullpunkt auf Prüfadapter"
      </Typography>
      <Box mt={2} />
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 8 }}>
          <TextField
            fullWidth
            label="Offset X (mm)"
            type="number"
            inputProps={{ step: 0.01 }}
            value={data.offset.x}
            onChange={(e) =>
              onChange("offset", {
                ...data.offset,
                x: parseFloat(e.target.value),
              })
            }
          />
          <Box mt={2} />
          <TextField
            fullWidth
            label="Offset Y (mm)"
            type="number"
            inputProps={{ step: 0.01 }}
            value={data.offset.y}
            onChange={(e) =>
              onChange("offset", {
                ...data.offset,
                y: parseFloat(e.target.value),
              })
            }
          />
          <Box mt={2} />
          <TextField
            select
            fullWidth
            label="Rotation (°)"
            inputProps={{ step: 0.01 }}
            value={data.rotation}
            onChange={(e) =>
              onChange("rotation", parseFloat(e.target.value))
            }
          >
          < MenuItem value="0">0</MenuItem>
          < MenuItem value="90">90</MenuItem>
          < MenuItem value="180">180</MenuItem>
          < MenuItem value="270">270</MenuItem>
          </TextField>
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <ImageBox
            width="100%"
            height={200}
            src="/mechanics/TestpointZeroPoint.png"
            srcDarkMode="/mechanics/TestpointZeroPoint_DarkMode.png"
            alt="Anordnung"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default DutToZeroMechanicsForm;